import { render, staticRenderFns } from "./RetailerCatalogProduct.vue?vue&type=template&id=5d0a1805&"
import script from "./RetailerCatalogProduct.vue?vue&type=script&lang=js&"
export * from "./RetailerCatalogProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports